import React from "react";

const Diners = ({fill}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1938 12.4812C17.1916 11.2133 16.8057 9.97568 16.087 8.93117C15.3682 7.88666 14.3501 7.08413 13.1667 6.62911V18.3333C14.3505 17.8789 15.369 17.0765 16.0879 16.0318C16.8067 14.9872 17.1923 13.7493 17.1938 12.4812ZM8.67708 18.3312V6.63015C7.49437 7.08561 6.47709 7.88819 5.75892 8.93246C5.04074 9.97672 4.65526 11.2138 4.65312 12.4812C4.65547 13.7484 5.04105 14.9853 5.75921 16.0293C6.47737 17.0734 7.49453 17.8758 8.67708 18.3312ZM10.9229 2.58848C8.29939 2.58876 5.78341 3.63115 3.92839 5.48636C2.07337 7.34157 1.03125 9.85766 1.03125 12.4812C1.03153 15.1042 2.07369 17.6196 3.92852 19.4742C5.78334 21.3289 8.2989 22.3708 10.9219 22.3708C12.2207 22.3709 13.5069 22.1152 14.7069 21.6183C15.907 21.1214 16.9974 20.3929 17.9159 19.4746C18.8344 18.5563 19.5631 17.466 20.0603 16.2661C20.5574 15.0662 20.8134 13.78 20.8135 12.4812C20.8127 9.85792 19.7703 7.34231 17.9155 5.48727C16.0606 3.63224 13.5451 2.58959 10.9219 2.58848H10.9229ZM10.899 23.3051C4.91979 23.3333 0 18.4895 0 12.5937C0 6.15098 4.91979 1.69369 10.899 1.69473H13.701C19.6062 1.69473 25 6.1489 25 12.5937C25 18.4874 19.6083 23.3051 13.7 23.3051"
      fill={fill}
    />
  </svg>
);

export default Diners;
